<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<div [ngClass]="['chart', chartType]">
	@if (isLoading) {
		<div
			class="chart-loading"
			[ngStyle]="{ height: height }"
		>
			<globalictcc-spinner />

			<span class="message">Loading...</span>
		</div>
	} @else {
		@if (hasError) {
			<div
				class="chart-error"
				[ngStyle]="{ height: height }"
			>
				<span class="icon-unlink"></span>

				<span class="message">
					Unable to load the data, please retry or contact support
				</span>

				<globalictcc-button
					label="Retry"
					iconName="update"
					[textOnly]="true"
					(handleClick)="handleChartRefresh.emit()"
				/>
			</div>
		} @else {
			@if (isDataPresent) {
				@if (isTitleVisible) {
					<span
						class="chart-title"
						[ngClass]="[titleAlignment, titleSize]"
					>
						{{ title }}

						@if (tooltip) {
							<span
								class="icon-warning"
								[ngxTippy]="tooltip"
							></span>
						}
					</span>
				}

				<div
					echarts
					class="chart-container"
					[options]="emptyOptions"
					[merge]="chartOptions"
					(chartInit)="onChartInit($event)"
					(chartClick)="handleChartClick.emit($event)"
				></div>
			} @else {
				<div
					class="no-data-chart"
					[ngStyle]="{ height: height }"
				>
					<span class="icon-warning-hex"></span>

					<span class="message">No data available</span>
				</div>
			}
		}
	}
</div>
